import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PublicReviewInterface } from 'src/app/model/reviews/public-review-interface';

@Component({
    selector: 'app-public-activity-item',
    templateUrl: './public-activity-item.component.html',
    styleUrls: ['./public-activity-item.component.css'],
    standalone: false
})
export class PublicActivityItemComponent implements OnInit {
    @Input()
    public review: PublicReviewInterface;

    @Input()
    public username: string;

    constructor(private router: Router) {}

    ngOnInit() {
    }


    openInNewTab(id: number) {
        window.open(`/marktplatz/products/${id}`, '_blank');
    }
  
    goToMarketPlatz(id: number) {
        this.router.navigateByUrl(`/marktplatz/products/${id}`)
    }
}
